import React, { useId, useState } from 'react';
import './ConcentrationTray.scss';

/** Collapsed by default; spell controllers retain ownership of their actions. */
export default function ConcentrationTray({ count, children }) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  if (!count) return null;
  return <section className="concentration-tray" aria-label="Concentration controls">
    <button type="button" className="concentration-tray__toggle" aria-expanded={expanded}
      aria-controls={id} onClick={() => setExpanded(value => !value)}>
      <span>Concentration <span className="concentration-tray__count">{count}</span></span>
      <span aria-hidden="true">{expanded ? '▾' : '▴'}</span>
    </button>
    {expanded && <div id={id} className="concentration-tray__items">{children}</div>}
  </section>;
}
